<template>
    <div id="FileUploadSettings">
        <div class="form-field">
            <label for="title-input" class="form-label">{{ $t("form.fieldLabel") }}</label>
            <input
                type="text"
                id="title-input"
                class="form-input"
                :placeholder="$t('calendar.title')"
                v-model="fieldLabelFile"
                @input="updateField"
            >
        </div>
        <div class="form-field">
            <label class="form-label">{{ $t("form.labelAlignment") }}</label>
            <div class="button-group">
                <button class="button" :class="{ active: align === 'left' }" @click="updateFileAlign('left')">{{ $t("form.left") }}
                </button>
                <button class="button" :class="{ active: align === 'right' }" @click="updateFileAlign('right')">{{ $t("form.right") }}
                </button>
                <button class="button" :class="{ active: align === 'top' }" @click="updateFileAlign('top')">
                    {{ $t("form.top") }}
                </button>
            </div>
            <small class="form-description">{{ $t("form.chooseLabelAlignment") }}</small>
        </div>
        <div class="form-field">
            <label for="title-input" class="form-label">{{ $t('chatWindow.tag') }}</label>
            <input
                type="text"
                id="title-input"
                class="form-input"
                :placeholder="$t('calendar.title')"
                v-model="altLabelOne"
                @input="updateAltLabelOne"
            >
        </div>
        <div class="form-field">
            <label for="title-input" class="form-label">{{ $t("form.subLabels") }}</label>
            <input
                type="text"
                id="title-input"
                class="form-input"
                :placeholder="$t('calendar.title')"
                v-model="altLabelTwo"
                @input="updateAltLabelTwo"
            >
        </div>
        <div class="form-field">
            <label class="form-label">{{ $t("form.required") }}</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: isRequired }"
                      @click="toggleRequired">{{ requiredText }}</span>
            </div>
            <small class="form-description">{{ $t("form.fieldEmptyError") }}</small>
        </div>

        <div class="form-field">
            <label class="form-label">Görünürlük</label>
            <div class="toggle">
                <span class="toggle-option" :class="{ active: visibility }"
                      @click="toggleVisibility">{{ visibility ? "Görünür" : "Gizli" }}</span>
            </div>
            <small class="form-description">Bu alanın form üzerinde görünür olup olmayacağını belirler</small>
        </div>

        <div class="form-field">
            <label for="slug-input" class="form-label">URL Parametresi</label>
            <input
                type="text"
                id="slug-input"
                class="form-input"
                placeholder="fileUpload"
                v-model="slug"
                @input="setSlug($event.target.value)"
            >
            <small class="form-description">URL parametrelerinde kullanılacak benzersiz tanımlayıcı</small>
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
    name: "FileUploadSettings",
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldLabelFile: this.item.fileUpload.fieldLabelFile,
            align: this.item.fileUpload.align,
            altLabelOne: this.item.fileUpload.altLabelOne,
            altLabelTwo: this.item.fileUpload.altLabelTwo,
            isRequired: this.item.fileUpload.isRequired,
            visibility: this.item.visibility !== undefined ? this.item.visibility : true,
            slug: this.item.slug || '',
            updateTimer: null,
        };
    },
    computed: {
        requiredText() {
            return this.isRequired ? this.$t("chatWindow.open") : this.$t("chatWindow.closed");
        },
    },
    methods: {
        ...mapActions("forms", ["updateFormField"]),
        updateFileAlign(alignment) {
            this.align = alignment;
            this.$emit("update-file-align", alignment);
            this.updateFields();
        },
        toggleRequired() {
            this.isRequired = !this.isRequired;
            this.$emit("update-file-required", this.isRequired);
            this.updateFields();
        },
        toggleVisibility() {
            this.visibility = !this.visibility;
            this.updateFields();
            this.$emit('update-visibility', this.visibility);
        },
        setSlug(slug) {
            this.slug = this.sanitizeSlug(slug);
            this.updateFields();
        },
        sanitizeSlug(slug) {
            if (!slug) return '';

            return slug
                .replace(/ğ/gim, "g")
                .replace(/ü/gim, "u")
                .replace(/ş/gim, "s")
                .replace(/ı/gim, "i")
                .replace(/ö/gim, "o")
                .replace(/ç/gim, "c")
                .replace(/[^a-z0-9-]/gim, "-")
                .replace(/-+/gim, "-")
                .replace(/^-|-$/gim, "")
                .toLowerCase();
        },
        updateField() {
            this.$emit("update-file-label", this.fieldLabelFile);
            this.updateFields();
        },
        updateAltLabelOne() {
            this.$emit("update-file-alt-label-one", this.altLabelOne);
            this.updateFields();
        },
        updateAltLabelTwo() {
            this.$emit("update-file-alt-label-two", this.altLabelTwo);
            this.updateFields();
        },
        updateFields() {
            let self = this;
            if (this.updateTimer) {
                clearTimeout(this.updateTimer);
            }
            this.updateTimer = setTimeout(function () {
                const updateFields = {
                    label: self.fieldLabelFile,
                    visibility: self.visibility,
                    slug: self.slug,
                    fileUpload: {
                        fieldLabelFile: self.fieldLabelFile,
                        align: self.align,
                        altLabelOne: self.altLabelOne,
                        altLabelTwo: self.altLabelTwo,
                        isRequired: self.isRequired,
                    },
                };
                self.updateFormField({
                    siteId: self.item.siteId,
                    formFieldId: self.item._id,
                    updateFields: updateFields,
                });
            }, 800);
        },
    },
    watch: {
        item: {
            handler: function (val) {
                if (!val || !val.fileUpload) { return; }
                this.fieldLabelFile = val.fileUpload.fieldLabelFile;
                this.align = val.fileUpload.align;
                this.altLabelOne = val.fileUpload.altLabelOne;
                this.altLabelTwo = val.fileUpload.altLabelTwo;
                this.isRequired = val.fileUpload.isRequired;
                this.visibility = val.visibility !== undefined ? val.visibility : true;
                this.slug = val.slug || '';
            },
            deep: true,
            immediate: false,
        },
        'item.fileUpload.fieldLabelFile': function (v) { this.fieldLabelFile = v; },
        'item.fileUpload.align': function (v) { this.align = v; },
        'item.fileUpload.altLabelOne': function (v) { this.altLabelOne = v; },
        'item.fileUpload.altLabelTwo': function (v) { this.altLabelTwo = v; },
        'item.fileUpload.isRequired': function (v) { this.isRequired = v; },
        'item.visibility': function (v) { this.visibility = v; },
        'item.slug': function (v) { this.slug = v || ''; },
    },
};
</script>
<style lang="scss" scoped>
#FileUploadSettings {
    padding: 8px 12px 24px 12px;

    .form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;

        .form-label {
            margin-bottom: 6px;
            font-weight: 600;
            color: #374151;
            font-size: 0.875rem;
            letter-spacing: 0.025em;
        }

        .form-input {
            padding: 8px 12px;
            border: 1px solid #d1d5db;
            border-radius: 8px;
            background-color: #ffffff;
            color: #374151;
            font-size: 0.875rem;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;

            &:focus {
                outline: none;
                border-color: #f26a52;
                box-shadow: 0 0 0 3px rgba(242, 106, 82, 0.1);
            }

            &::placeholder {
                color: #9ca3af;
            }
        }

        .button-group {
            display: flex;
            gap: 4px;
            margin-bottom: 8px;

            .button {
                flex: 1;
                padding: 6px 8px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;

                &.active {
                    background-color: #f26a52;
                    color: #ffffff;
                    border-color: #f26a52;
                    box-shadow: 0 1px 3px rgba(242, 106, 82, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }

        .form-description {
            margin-top: 4px;
            font-size: 0.75rem;
            color: #9ca3af;
            line-height: 1.3;
        }

        .toggle {
            display: flex;
            align-items: center;

            .toggle-option {
                padding: 8px 16px;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                background-color: #f9fafb;
                color: #6b7280;
                font-size: 0.8rem;
                font-weight: 500;
                cursor: pointer;
                text-align: center;
                transition: all 0.2s ease;
                min-width: 80px;

                &.active {
                    background-color: #10b981;
                    color: #ffffff;
                    border-color: #10b981;
                    box-shadow: 0 1px 3px rgba(16, 185, 129, 0.3);
                }

                &:hover:not(.active) {
                    background-color: #f3f4f6;
                    border-color: #d1d5db;
                }
            }
        }
    }
}
</style>
